import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import InchSquared from "../../../../components/Math/Units/Imperial/InchSquared";
import MillimetreSquared from "../../../../components/Math/Units/Metric/MillimetreSquared";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import { selectAreaOfGrout } from "../../../../store/slices/fhwaSlice";

function AreaOfGrout() {
  const { t } = useTranslation("translation");
  const areaOfGrout = useSelector(selectAreaOfGrout);

  const metricUnit = <MillimetreSquared />;
  const imperialUnit = <InchSquared />;

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Area of Grout")}</p>}
      indicesValue={
        <span>
          A<sub>g</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={areaOfGrout.current} decimalScale={2} />
        </span>
      }
      formulaValue={
        <ToolTip
          id={"AreaOfGroutInfoText"}
          type={IconType.INFO}
          text={t("aashto.inner.Ag_InfoText")}
        />
      }
      unitValue={<ConvertUnit Metric={metricUnit} Imperial={imperialUnit} />}
    />
  );
}

export default AreaOfGrout;
